import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  FaCheck,
  FaCoins,
  FaCopy,
  FaDiscord,
  FaMedium,
  FaRankingStar,
  FaSquareXTwitter,
  FaUsers,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import TwitterLogin from "react-twitter-login";

import { BASE_URL, CDN_BASE_URL } from "../../config";
import { getUser } from "../../api/getUser";
import Loading from "../common/Loading";
import MediumModal from "../common/modals/MediumModal";
import TwitterModal from "../common/modals/TwitterModal";
import { httpReauest } from "../../utils/httpRequest";

const UserInvites = ({ data }) => {
  const [users, setusers] = useState();
  const [loading, setloading] = useState(true);
  const [copied, setcopied] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [navigate]);

  async function getData(params) {
    const user = JSON.parse(localStorage.getItem("user"));

    const res = await httpReauest(
      "GET",
      "/user/ref/" + user?._id,
      {},
      { "x-access-token": user?.token }
    );
    setusers(res.data?.data);
    setloading(false);
  }

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      throw new Error("Invalid date provided");
    }

    const day = date.getDate();
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  const lastChar = data?._id.slice(-1); // آخرین کاراکتر
  const lastCharAsNumber = parseInt(lastChar, 16); // تبدیل به عدد (0 تا 15)
  const imageNumber = (lastCharAsNumber % 9) + 1; // عدد بین 1 تا 9

  const text = `https://airdrop.filetrust.io?ref=${data?.refCode || null}`;

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(text);
      console.log("متن با موفقیت کپی شد");
    } catch (err) {
      console.error("خطا در کپی کردن متن:", err);
    }
  }

  return (
    <>
      <div className="rounded-[66px] bg-[#4A5A69] px-4 py-6 lg:p-5  flex lg:flex-row  w-full flex-wrap justify-between items-center relative">
        <h2 className="text-center font-bold text-[24px] lg:text-[34px] mb-1 relative w-full">
          Invite Friends
        </h2>
        <p className="text-center w-full">
          for every user you invite you get Trust point, for more information go
          to the help
        </p>
        <div className="w-full flex justify-center mt-5 relative gap-2">
          <input
            value={text}
            className="max-w-[320px] w-full h-[52px]  bg-[#1C2143] rounded-[12px] px-4 outline-none text-white"
            disabled
          />
          <button
            onClick={() => {
              copyToClipboard();
              setcopied(true);
              setTimeout(() => {
                setcopied(false);
              }, 3000);
            }}
            className="h-[52px] w-[52px] flex justify-center items-center bg-[#1C2143] rounded-[12px] text-white"
          >
            {copied ? (
              <FaCheck color="green" size={24} />
            ) : (
              <FaCopy size={24} />
            )}
          </button>
        </div>
      </div>

      <div className="rounded-[66px] bg-[#4A5A69] p-3 lg:px-4 py-5 lg:py-6 gap-5 w-full  relative mt-5">
        <h2 className="text-center font-bold text-[24px] lg:text-[34px] mb-6 relative">
          Your Friends ({users?.length})
          <FaUsers className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ecebeb] text-[34px] lg:text-[54px]" />
        </h2>
        <div className="flex flex-col gap-3 lg:gap-4 lg:max-h-[50vh] lg:overflow-y-scroll lg:px-4">
          {users?.map((item, index) => {
            // گرفتن آخرین کاراکتر _id و تبدیل آن به عدد (مبنای 16)
            const lastChar = item._id.slice(-1); // آخرین کاراکتر
            const lastCharAsNumber = parseInt(lastChar, 16); // تبدیل به عدد (0 تا 15)
            const imageNumber = (lastCharAsNumber % 9) + 1; // عدد بین 1 تا 9

            return (
              <div
                key={item._id}
                className="flex w-ful justify-between items-center gap-3 bg-[#0E171D] p-3 rounded-[40px]"
              >
                <span className="flex w-full lg:w-fit justfy-start gap-2 lg:gap-4 items-center">
                  <img
                    src={`/profile/${item?.gender?.toLowerCase()}/${
                      item?.level > 6 ? 6 : item?.level
                    }.jpg`}
                    className="w-16 lg:w-28"
                    alt="User Profile"
                  />
                  <span>
                    <h2 className="font-bold text-[24px] lg:text-[32px]">
                      {item?.name}
                    </h2>
                    <p className=" text-[14px] lg:text-[18px]">
                      Joined:{" "}
                      {item
                        ? new Date(item?.createdAt).toLocaleDateString()
                        : null}
                    </p>
                  </span>
                </span>
                <span>
                  <h4 className="text-[20px] lg:text-[30px] text-center font-bold pe-2 lg:pe-6">
                    {item?.balance} FileTrust
                  </h4>
                  <h4 className="text-[24px] lg:text-[35px] text-center font-bold pe-2 lg:pe-6">
                    #{index + 1}
                  </h4>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default UserInvites;
